import React from 'react';
import Popup from "./Popup";

type PhoneVerificationInfoPopupProps = {
    onClose: () => void;
}

export const PhoneVerificationInfoPopup: React.FC<PhoneVerificationInfoPopupProps> = ({ onClose }) => (
    <Popup onClose={onClose}>
        <div className="security-info-popup">
            <h3 className="H3_21">Как работает проверка телефона?</h3>
            
            <div className="security-section">
                <h4 className="Subheader_17">Процесс проверки</h4>
                <p>
                    Система автоматически проверяет номер телефона подписанта по публичным черным спискам. 
                    Проверка осуществляется для защиты от мошеннических действий и недобросовестных клиентов.
                    <strong>Функция работает только для российских номеров телефонов.</strong>
                </p>
                <p>
                    При подписании договора у подписанта будет проверяться:
                </p>
                <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px'}}>
                    <li>Наличие номера в публичных черных списках</li>
                    <li>История использования номера</li>
                    <li>Соответствие номера российскому формату</li>
                </ul>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Что происходит при проверке?</h4>
                <p>
                    Если номер телефона не найден в черных списках, договор будет автоматически подписан.
                    Если номер найден в черных списках или требует дополнительной проверки, договор будет переведен в статус ожидания подтверждения.
                </p>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Не российские номера телефонов</h4>
                <p>
                    Если подписант ввел не российский номер телефона:
                </p>
                <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px'}}>
                    <li>Договор будет переведен в статус "Ожидает проверки"</li>
                    <li>Вы получите уведомление о том, что номер не российский</li>
                    <li>Попросите подписанта использовать российский номер телефона</li>
                </ul>
            </div>
        </div>
    </Popup>
); 